"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipperSchema = void 0;
const yup = __importStar(require("yup"));
const zipperAttributes_1 = require("../attributes/zipperAttributes");
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
const additionInfoSchema = shared.sentenceSetSchema.optional();
exports.ZipperSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Zippers),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.SellingUnit)),
    zipperType: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.ZipperType)),
    zipperHardwareType: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.ZipperHardwareType)),
    zipperHardwareSU: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.ZipperHardwareSU)),
    material: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.Material)),
    zipperHardwareMaterial: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.ZipperHardwareMaterial)),
    closure: utils_1.reqSelectOneSchema(Object.values(zipperAttributes_1.Closure)),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    lengthIn: shared.widthLengthBaseSchema.min(3).required(),
    widthMM: shared.widthMMSchema,
    quality: shared.qualitySchema,
    brand: shared.brandSchema,
    // This needs to be casted back to an array from an varianted form
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    uses: shared.usesSchema,
    packSize: shared.packSizeSchema,
    quantity: shared.quantitySchema.required(),
    price: shared.priceSchema,
    additionalInfo: additionInfoSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case zipperAttributes_1.SellingUnit.Individual:
            return schema.omit([
                'material',
                'packSize',
                'zipperHardwareType',
                'zipperHardwareSU',
                'zipperHardwareMaterial'
            ]);
        case zipperAttributes_1.SellingUnit['Pack']:
            return schema.omit([
                'material',
                'zipperHardwareType',
                'zipperHardwareSU',
                'zipperHardwareMaterial'
            ]);
        case zipperAttributes_1.SellingUnit['Tape By The Meter']:
            return schema.omit([
                'material',
                'closure',
                'lengthIn',
                'brand',
                'uses',
                'packSize',
                'zipperHardwareType',
                'zipperHardwareSU',
                'zipperHardwareMaterial'
            ]);
        case zipperAttributes_1.SellingUnit.Hardware:
            return schema.omit([
                'zipperType',
                'closure',
                'lengthIn',
                'uses',
                'material'
            ]);
        default:
            return schema;
    }
})
    .test('Context Check', "Zipper Validator needs zipper product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=zipperSchema.js.map